import jump from "jump.js";

const getPageOffset = () => {
  let offset = 0;

  const siteHeader = document.querySelector(".site-header");

  if (siteHeader) {
    const siteHeaderHeight = getComputedStyle(document.documentElement).getPropertyValue("--site-header-height");

    offset += parseInt(siteHeaderHeight);
  }

  return offset;
};

const scrollTo = (target, additionalOffset = 0) => {
  const pageOffset = getPageOffset() * -1;

  if (target.dataset.scrollOffset) {
    additionalOffset = parseInt(target.dataset.scrollOffset);
  }

  let offset = pageOffset - additionalOffset;

  return new Promise((resolve) => {
    jump(target, {
      duration: 600,
      offset,
      callback: () => {
        resolve();
      },
    });
  });
};

export const scrollToIfNeeded = (target, additionalOffset = 0) => {
  const rect = target.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const isInViewport = rect.top >= 0 && rect.bottom <= viewportHeight;
  const is50PercentFromTop = rect.top <= viewportHeight / 2;

  if (!isInViewport || !is50PercentFromTop) {
    return scrollTo(target, additionalOffset);
  }
};

export default scrollTo;
